import React, { useEffect, useState } from 'react'
import classes from "../UserDetails/style.module.scss";
import ScrollableTable from '../../../../component/ScrollableTable';

const DealersTable = () => {

    const [page, setPage] = useState(1);
    const [userList, setUserList] = useState({});
    const [isLoading, setisLoading] = useState(false);
    const [sortedColumns, setSortedColumns] = useState(null);

    const userHeader = [
        { label: 'User Name', sortable: true },
        { label: 'Start Date' },
        { label: 'End Date' },
        { label: 'Start Time' },
        { label: 'End Time' },
    ];

    const list = [
        { userName: "Sharma", startDate: "22 Aug 2024", endDate: "22 Aug 2024", startTime: "10 :00 AM", endTime: "6:00 PM" },
        { userName: "Aarav Sharma", startDate: "22 Aug 2024", endDate: "22 Aug 2024", startTime: "10 :00 AM", endTime: "6:00 PM" },
        { userName: "Aarav Sharma", startDate: "22 Aug 2024", endDate: "22 Aug 2024", startTime: "10 :00 AM", endTime: "6:00 PM" },
        { userName: "Aarav Sharma", startDate: "22 Aug 2024", endDate: "22 Aug 2024", startTime: "10 :00 AM", endTime: "6:00 PM" },
        { userName: "Aarav Sharma", startDate: "22 Aug 2024", endDate: "22 Aug 2024", startTime: "10 :00 AM", endTime: "6:00 PM" },
        { userName: "Aarav Sharma", startDate: "22 Aug 2024", endDate: "22 Aug 2024", startTime: "10 :00 AM", endTime: "6:00 PM" },
        { userName: "Aarav Sharma", startDate: "22 Aug 2024", endDate: "22 Aug 2024", startTime: "10 :00 AM", endTime: "6:00 PM" },
        { userName: "Aarav Sharma", startDate: "22 Aug 2024", endDate: "22 Aug 2024", startTime: "10 :00 AM", endTime: "6:00 PM" },
    ]

    const getUserList = async () => {
        setisLoading(true)
        // const body = {
        //     slug: `page=${page}&limit=10`
        // }
        // const response = await dispatch(slotBookedList({
        //     ...body
        // }))
        const obj = {
            result: list,
            pageMeta: {}
            // result: response?.payload?.data?.list,
            // pageMeta: response?.payload?.data?.pageMetaData
        }
        setUserList(obj)
        setisLoading(false)
    }

    useEffect(() => {
        getUserList()
    }, [page])

    const handleTableData = (keyValue, defaultValue, className = '') => {
        return (
            <div className={`${className} w-[50%]`}>{keyValue ? keyValue : defaultValue}</div>
        )
    };

    return (
        <div className={`${classes.userCardWrapper} mb-4`}>
            <div className={`${classes.informationTitle}`}>
                Dealers
            </div>

            <div className={`my-5 scrollTableWrapper`}>
                <ScrollableTable
                    headerDetails={userHeader}
                    listLength={userList?.result || []}
                    isLoading={isLoading}
                    tableSort
                    sortedColumns={sortedColumns}
                    setSortedColumns={setSortedColumns}
                >
                    {userList?.result?.map((item, index) => {
                        const { userName = '', startDate = '', endDate = '', startTime = '', endTime = '', id = '' } = item;
                        return (
                            <div className={`flex items-center rowTableData `} key={userName}>
                                {handleTableData(userName, '-', 'text-center')}
                                {handleTableData(startDate, '-', 'text-center')}
                                {handleTableData(endDate, '-', 'text-center')}
                                {handleTableData(startTime, '-', 'text-center')}
                                {handleTableData(endTime, '-', 'text-center')}
                            </div>
                        );
                    })}
                </ScrollableTable>
            </div>
        </div>
    )
}

export default DealersTable